import { useQuery } from "@tanstack/react-query";
import ExhibitorService from "../services";
import { SortField } from "../../../utils/schema/SortType";
import qs from "qs";

interface UseExhibitorsParams {
  sortFields?: SortField[];
  page?: number;
  rowsPerPage?: number;
  searchText?: string;
  filters?: any; 
}

export const useExhibitors = ({
  sortFields,
  page,
  rowsPerPage,
  searchText,
  filters,
}: UseExhibitorsParams = {}) => {

  const sortParam = sortFields
    ? sortFields.map(({ field, order }) => `${field}:${order}`)
    : undefined;

  const query = qs.stringify(
    {
      sort: sortParam,
      pagination: {
        page,
        pageSize: rowsPerPage,
      },
      populate: "*",
      filters: searchText
      ? {
          name: {
            $contains: searchText,
          },
        }
      : filters,
    },
    { encodeValuesOnly: true }
  );
  return useQuery({
    queryKey: ["exhibitors",query],
    queryFn: () => ExhibitorService.getAll({query}),
    // keepPreviousData: true,
  });
};
